<div class="wrap-container">
  <div>
    <h2>{{ 'deleteUser.title' | translate }}</h2>
    <p>
      {{ 'deleteUser.intro' | translate: { brand: brandService.config.brandName } }}
    </p>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <!-- Name Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'deleteUser.nameLabel' | translate }}</mat-label>
        <input matInput formControlName="fullName" />
        <mat-error *ngIf="form.get('fullName')?.hasError('required')">
          {{ 'deleteUser.errors.nameRequired' | translate }}
        </mat-error>

      </mat-form-field>

      <!-- Email Field -->
      <mat-form-field appearance="fill">
        <mat-label>{{ 'deleteUser.emailLabel' | translate }}</mat-label>
        <input matInput formControlName="email" />
        <mat-error *ngIf="form.get('email')?.hasError('required')">
          {{ 'deleteUser.errors.emailRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('email')">
          {{ 'deleteUser.errors.emailInvalid' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('email')?.hasError('emailNotFound')">
          {{ 'deleteUser.errors.emailNotFound' | translate }}
        </mat-error>
      </mat-form-field>

      <!-- Reasons -->
       <div>
        <h3>{{ 'deleteUser.reasonsHeading' | translate }}</h3>
        <div formArrayName="selected_reasons">
          <div *ngFor="let reasonCtrl of reason.controls; let i = index" [formGroupName]="i">
            <app-styled-checkbox formControlName="value">
              {{ reasons[i].labelKey | translate }}
            </app-styled-checkbox>
          </div>
        </div>
       </div>

      <!-- Text Field for "Other" Reason -->
        <div *ngIf="this.reason.at(this.reasons.length - 1).get('value').value">
          <mat-form-field appearance="fill">
            <mat-label>{{ 'deleteUser.otherReasonLabel' | translate }}</mat-label>
            <input matInput formControlName="custom_reason"/>
          </mat-form-field>
        </div>
      <!-- Information Erasure -->
      <div>
        <h3>{{ 'deleteUser.informationErasureHeading' | translate }}</h3>
        <mat-radio-group
          formControlName="informationErasure"
          (change)="onEraseTypeChange($event.value)">
          <mat-radio-button value="erase_all">{{ 'deleteUser.eraseAll' | translate }}</mat-radio-button>
          <mat-radio-button value="specific_info">{{ 'deleteUser.eraseSpecific' | translate }}</mat-radio-button>
        </mat-radio-group>
        <mat-error *ngIf="form.get('informationErasure')?.touched && form.get('informationErasure')?.hasError('required')">
          {{ 'deleteUser.errors.optionRequired' | translate }}
        </mat-error>
      </div>

     <!-- Specific Information -->
      <div  *ngIf="form.get('informationErasure')?.value === 'specific_info'">
        <h3>{{ 'deleteUser.specificInfoHeading' | translate }}</h3>
        <div formArrayName="specificInfoToErase">
          <div *ngFor="let ctrl of specificInfoToErase.controls; let i = index" class="checkbox-group"  [formGroupName]="i">
            <app-styled-checkbox formControlName="value">
              {{ informationToEraseArray[i].labelKey | translate }}
            </app-styled-checkbox>
          </div>
        </div>
        <mat-error *ngIf="specificInfoRequired">
          {{ 'deleteUser.errors.atLeastOneRequired' | translate }}
        </mat-error>
      </div>
      <p *ngIf="!isSuccessMessage">
        {{ 'deleteUser.privacyNotice' | translate }}
      </p>

      <!-- Submit Button -->
      <div class="submit-button" *ngIf="!isSuccessMessage">
        <button mat-flat-button type="submit" [disabled]="isSubmitting">
          {{ (isSubmitting ? 'deleteUser.submitting' : 'deleteUser.submit') | translate }}
        </button>
      </div>
      <div *ngIf="isSuccessMessage">
        <h1>{{ 'deleteUser.thankYouTitle' | translate }}</h1>
        <p>{{ 'deleteUser.thankYouMessage' | translate }}</p>
      </div>
    </form>
  </div>
</div>
